export enum ProviderStatus {
    Active = 'active',
    Inactive = 'inactive',
}

export enum FileTypes {
    //  Allocation Request
    DEPOSIT_COMPLETED = 'deposit_completed',
    DEPOSIT_COMPLETED_CONFIRMATION = 'deposit_completed_confirmation',

    WITHDRAWAL_START = 'withdrawal_start',
    WITHDRAWAL_START_CONFIRMATION = 'withdrawal_start_confirmation',

    // Market Orders
    MARKET_ORDER_CREATED = 'MARKET_ORDER_CREATED',
    MARKET_ORDER_STARTED = 'MARKET_ORDER_STARTED',
    MARKET_ORDER_STARTED_PENDING_CONFIRMATION = 'MARKET_ORDER_STARTED_PENDING_CONFIRMATION',
    MARKET_ORDER_COMPLETED = 'MARKET_ORDER_COMPLETED',
    MARKET_ORDER_COMPLETED_PENDING_CONFIRMATION = 'MARKET_ORDER_COMPLETED_PENDING_CONFIRMATION',

    // Dividends
    DIVIDEND_ADDED = 'DIVIDEND_ADDED',
    DIVIDEND_ADDED_CONFIRMATION = 'DIVIDEND_ADDED_CONFIRMATION',

    // Settlments
    SETTLEMENTS_ADDED = 'SETTLEMENTS_ADDED',
}

export enum AttachementType {
    CSV = 'csv',
    PDF = 'pdf',
    IMAGE = 'image',
}

export enum FileExtentions {
    PDF = 'pdf',
    CSV = 'csv',
    PNG = 'png',
    JPG = 'jpg',
    JPEG = 'jpeg',
    WEBP = 'webp',
}

export enum StatusFilter {
    ACTIVE = 'active',
    HISTORICAL = 'historical',
}

export enum Providers {
    ALPACA = 'alpaca',
    ARC = 'arc',
    DERAYAH = 'derayah',
    JADWA = 'JADWA',
    MANUAL_DERAYAH_CUSTOM = 'MANUAL_DERAYAH_CUSTOM',
    MANUAL_DERAYAH_MAIN = 'MANUAL_DERAYAH_MAIN',
    SNBC = 'SNBC',
}

export enum GoogleLoginEnabledApps {
    MANUAL_INVESTMENT_ENGINE = 'manual_investment_engine',
    BACKOFFICE = 'backoffice',
}

export enum AllocationRequestType {
    DEPOSIT = 'deposit',
    WITHDRAWAL = 'withdrawal',
}
